<template>
  <div class="emat-order-action">
      <green-check-svg class="icon" />
      <span class="label">
        Levertijd
        <span class="bold">{{ label }}</span>
      </span>
  </div>
</template>

<script>
import GreenCheckSvg from "../../../assets/icons/checkmark-green.svg?inline";
export default {
  name: 'OrderAction',
  props: {
    /**
     * Unique name for your layout
     */
    name: {
      type: String,
      required: true,
    },
    /**
     * Label (black) {use as: [label="label"]}
     */
    label: {
      type: String,
      required: true,
      default: '',
    },
    /**
     * Extra (green bold) {use as: [extra="extra"]}
     */
    extra: {
      type: String,
      required: false,
      default: '',
    },
  },
  components: {
    GreenCheckSvg
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/abstracts";
  .emat-order-action {
    padding: 11px 0 9px 36px;
    max-height: 32px;
    background-color: var(--c-primary-lightest);
    line-height: 1;
    position: relative;

    .icon {
      position: absolute;
      left: 12px;
      top: 50%;
      transform: translateY(-50%);
    }
    .label {
      display: block;
      width: auto;
      font-size: 12px;
      flex-wrap: nowrap;
      font-family: var(--font);

      .bold {
        font-family: var(--font-black);
      }
    }
    .extra {
      color: #74B800;
      font-family: var(--font);
      font-weight: bold;
      font-size: 12px;
    }
  }
</style>
